export default {
  0: [  //Composer
    "14.92%",
    "13.56%",
    "11.87%",
    "10.17%",
    "8.48%",
    "6.78%",
    "4.97%",
    "3.39%",
    "1.7%",
    "0%"
  ],
  1: [
    "18.15%",
    "23.93%",
    "25.57%"
    ],
  2: {
    0: [
      "12.09%",
      "6.04%"
    ],
    1: [
      "16.05%",
      "8.02%"
    ],
    2: [
      "19.97%",
      "9.98%"
    ]
  },
  3: [
    "12%",
    "9.40%",
    "6%"
    ],
  5: {  //Ronds
    0: [
      "2.66%",  //    P3E16
      "1.70%",   //    P3E20
      "0.66%"    //    P3E32
    ],
    1: [
      "10.62%",    //    P6E16
      "6.80%",   //    P6E20
      "2.66%"    //    P6E32
    ],
    2: [
      "18,90%",   //P8E16
      "12,10%",//P8E20
      "4,72%", //P8E32
    ],
    3: [
      "18.90%", //P10E20
      "7.37%"  //P10E32
    ]
  },

  4: "6.06%",
  6: [
    "12.12%",
    "n.c.",
    "n.c.",
    "n.c.",
    "n.c."
  ],
  7: [
    "n.c.",
    "n.c.",
    "n.c.",
    "n.c.",
    "n.c."
  ],
  8: [
    "8.54%",
    "8.54%",
    "8.54%",
    "8.54%",
    "8.54%",
    "8.54%"
  ],
  9: [
    "n.c.",
    "n.c.",
    "n.c.",
    "n.c.",
    "6,89%"
  ],
  10: [  //souffler
    "8.54%",
    "8.54%",
    "8.54%",
    "8.54%",
    "8.54%",
    "8.54%",
    "8.54%",
    "8.54%"
  ],
  11: "8.2%", //prairie
  12: "6.2%", //brindille
  13: "34.2%", // taillis
  14: "12.2%",//Ecorce",
  15: "3.1%",//Liane",
  16: "15.1%",//Chair de poule",
  17: "4.2%",//Grain de beauté",
  18: "10.9%",//Ecaille",
  19: "1.7%",//Fourrure",
  20: "11.9%",//Ligne de vie",
  21: "3.7%",//Canevas",
  22: "7.3%",//Patchwork",
  23: "31.8%",//Jersey",
  24: "0.8%",//Capiton",
  25: "15.6%",//Ecossais",
  26: "1.4%",//Brume",
  27: "10.4%",//Pluie",
  28: "2.6%",//Soleil",
  29: "4.7%",//Vent",
  30: "12.3%",//Neige",
  31: "11.7%",//Amplitude",
  32: "12%",//Onde",
  33: "28.6%",//Crépitement",
  34: "7.1%",//Cadence",
  35: "20.2%"//Fréquence
}



// WEBPACK FOOTER //
// ./src/constants/patternPerforationRatios.js